import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Decadence} from "../Decadence";
import {DecadenceGameAssets} from "../DecadenceGameAssets";
import {gsap} from "gsap"
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {DecadenceForegroundElements} from "./DecadenceForegroundElements";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {PopUpResponseData} from "@nolimitcity/slot-keypad/bin/core/view/betpanel/parts/ConfirmBetPopUpView";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {DecadenceStatics} from "../config/DecadenceStatics";
import {DecadenceReelsView} from "./DecadenceReelsView";

class ReelSelectButton extends PIXI.Container {
    animation:PIXI.spine.Spine;
    clickArea:PIXI.Sprite;

    reelMode:number;

    constructor(reelMode:number) {
        super();
        this.name = "ReelSelectButton_" + reelMode;
        this.reelMode = reelMode;

        this.animation = DecadenceGameAssets.createSpine(DecadenceGameAssets.BUTTON_ANIMATION);
        this.animation.skeleton.setSkinByName(reelMode.toString());
        this.animation.state.setAnimation(0, "off", true);

        this.clickArea = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.clickArea.interactive = true;
        this.clickArea.anchor.set(0.5, 0.5);
        this.clickArea.width = this.animation.width-10;
        this.clickArea.height = this.animation.height-10;
        this.clickArea.alpha = 0;

        this.addChild(this.animation, this.clickArea);
    }

    setClickCallback(callback:Function) {
        this.clickArea.on("mousedown", () => callback());
        this.clickArea.on("tap", () => callback());
    }

    disableClickArea() {
        this.clickArea.interactive = false;
    }
    enableClickArea() {
        this.clickArea.interactive = true;
    }

    turnOnButton():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                if(this.reelMode != 1) {
                    Decadence.soundPlayer.playSoundNoOverlap("changeReelsTo2Or3");
                } else {
                    Decadence.soundPlayer.playSoundNoOverlap("changeReelsTo1");
                }
            })
            .add(SpineGSAPWrapper.createTimeline(this.animation, 0, "turn_on"))
            .add(() => {
                this.animation.state.setAnimation(0, "on", true);
            })
    }
    turnOffButton():gsap.core.Timeline {
        return gsap.timeline()
            .add(SpineGSAPWrapper.createTimeline(this.animation, 0, "turn_off"))
            .add(() => {
                this.animation.state.setAnimation(0, "off", true)
            })
    }
}


export class DecadenceReelSelectView extends PIXI.Container implements StageLayer {

    private selectedReelMode:number = 1;

    private buttonContainer:PIXI.Container;

    private button1:ReelSelectButton;
    private button2:ReelSelectButton;
    private button4:ReelSelectButton;

    private availableButtons:ReelSelectButton[] = [];


    private tl:gsap.core.Timeline;

    constructor() {
        super();
        this.name = "ReelSelectView";

        this.button1 = new ReelSelectButton(1);
        this.button2 = new ReelSelectButton(2);
        this.button4 = new ReelSelectButton(4);
        this.availableButtons.push(this.button1, this.button2, this.button4);


        this.buttonContainer = new PIXI.Container;
        this.buttonContainer.addChild(this.button1, this.button2, this.button4);
        this.button2.position.x += this.button1.width;
        this.button4.position.x += this.button1.width * 2;

        // Reel1 Mode selected by default
        this.tl = this.button1.turnOnButton();
        this.selectedReelMode = 1;
        this.button1.disableClickArea();

        this.addChild(this.buttonContainer);
        this.buttonContainer.position.set(
            230,
            660
        );

        // Disable non allowed booster buttons
        const allowedFeatures = Decadence.apiPlugin.betFeatureController.getAllowedFeatures();
        const reelMode2Allowed = allowedFeatures.find(f => f.name == "REELS_2") != undefined;
        const reelMode4Allowed = allowedFeatures.find(f => f.name == "REELS_4") != undefined;
        if(!reelMode2Allowed) {
            this.button2.visible = false;
            this.button2.disableClickArea();
        }
        if(!reelMode4Allowed) {
            this.button4.visible = false;
            this.button4.disableClickArea();
        }

        // Hide entire reel select view if no boosters are allowed
        this.visible = (reelMode2Allowed || reelMode4Allowed);


        Decadence.apiPlugin.events.on(APIEvent.CURRENT_BET, (data:any) => {
            this.onBetLevelChanged();
        })

        const buttonCallback = (feature?:string) => {
            Decadence.soundPlayer.playSound("changeReelsClick");
            this.setGameFeature(feature);
        }

        this.button1.setClickCallback(() => buttonCallback(undefined));
        this.button2.setClickCallback(() => buttonCallback("REELS_2"));
        this.button4.setClickCallback(() => buttonCallback("REELS_4"));
        this.onBetLevelChanged();
        this.onResize();
    }

    private onBetLevelChanged() {
        // Ignore for restoreing in to free feature bet
        const allowedFeatures = Decadence.apiPlugin.betFeatureController.getAllowedFeatures();
        const reelMode2 = allowedFeatures.find(f => f.name == "REELS_2");
        const reelMode4 = allowedFeatures.find(f => f.name == "REELS_4");
        if(reelMode2) {
            if(!reelMode2.isBetLevelValid()) {
                this.button2.disableClickArea();
                this.button2.alpha = 0.3;
                if(this.availableButtons.indexOf(this.button2) != -1) {
                    this.availableButtons.splice(this.availableButtons.indexOf(this.button2), 1);
                }
                if(this.selectedReelMode == 2) {
                    this.setButtonStatesFromFeature(undefined);
                    this.selectedReelMode = 1;
                }
            } else {
                if(!Decadence.model.isRestore) {
                    this.button2.enableClickArea();
                }
                this.button2.alpha = 1;
                if(this.availableButtons.indexOf(this.button2) == -1) {
                    this.availableButtons.push(this.button2);
                }
            }
        }
        if(reelMode4) {
            if(!reelMode4.isBetLevelValid()) {
                this.button4.disableClickArea();
                this.button4.alpha = 0.3;
                if(this.availableButtons.indexOf(this.button4) != -1) {
                    this.availableButtons.splice(this.availableButtons.indexOf(this.button4), 1);
                }
                if(this.selectedReelMode == 4) {
                    this.setButtonStatesFromFeature(undefined);
                    this.selectedReelMode = 1;
                }
            } else {
                if(!Decadence.model.isRestore) {
                    this.button4.enableClickArea();
                }
                this.button4.alpha = 1;
                if(this.availableButtons.indexOf(this.button4) == -1) {
                    this.availableButtons.push(this.button4);
                }
            }
        }

        if(this.availableButtons.length == 1) debugger
    }

    private setGameFeature(featureName?:string) {
        if(!featureName) {
            Decadence.apiPlugin.betFeatureController.setActiveBetFeature();
        } else {
            const activeFeature = Decadence.apiPlugin.betFeatureController.getActiveBetFeature();
            if(activeFeature?.name != featureName) {
                if(Decadence.apiPlugin.betFeatureController.shouldShowWarningPopUp(featureName)) {
                    SlotKeypad.showConfirmFeatureBetPopUp(featureName).then((data:PopUpResponseData) => {
                        if(data.confirmed) {
                            Decadence.apiPlugin.betFeatureController.setActiveBetFeature(featureName);
                            if(data.dontShowNextTime) {
                                Decadence.apiPlugin.betFeatureController.dontShowWarningNextTime(featureName);
                            }
                        } else {
                            Decadence.apiPlugin.betFeatureController.setActiveBetFeature();
                        }
                    })
                } else {
                    Decadence.apiPlugin.betFeatureController.setActiveBetFeature(featureName);
                }
            }
        }
    }


    lockButtons() {
        this.availableButtons.forEach((button, reelMode) => {
            button.disableClickArea();
        })
    }
    unlockButtons() {
        this.availableButtons.forEach((button) => {
            if(button.reelMode != this.selectedReelMode) {
                button.enableClickArea();
            }
        })
    }


    // Called by feature bet changed event in Decadence.ts in order to wait for the confirm button to be pressed by player
    setButtonStatesFromFeature(featureName?:string) {
        this.tl.progress(1);
        this.tl = gsap.timeline();
        const selectedButton = this.selectedReelMode == 4 ? this.button4 : (this.selectedReelMode == 2 ? this.button2 : this.button1);
        this.tl.add(selectedButton.turnOffButton(), 0);
        switch (featureName) {
            //case "SUPER_FREESPIN":
            //case "GOD_MODE":
            //case "FREESPIN":
            case undefined: {
                const button = this.button1;
                this.tl.add(() => {
                    button.disableClickArea();
                    this.selectedReelMode = 1;
                }, "<")
                this.tl.add(button.turnOnButton(), "<");
                break;
            }
            //case "SUPER_FREESPIN_REELS_2":
            //case "FREESPIN_REELS_2":
            case "REELS_2": {
                const button = this.button2;
                this.tl.add(() => {
                    button.disableClickArea();
                    this.selectedReelMode = 2;
                }, "<")
                this.tl.add(button.turnOnButton(), "<");
                break;
            }
            //case "SUPER_FREESPIN_REELS_4":
            //case "FREESPIN_REELS_4":
            case "REELS_4": {
                const button = this.button4;
                this.tl.add(() => {
                    button.disableClickArea();
                    this.selectedReelMode = 4;
                }, "<")
                this.tl.add(button.turnOnButton(), "<");
                break;
            }

            // Feature other than booster was selected
            default: {
                this.tl.add(() => {
                    if(!Decadence.model.isRestore && !Decadence.apiPlugin.promotionHandler.hasFreeFeatureBet()) {
                        this.availableButtons.forEach(b => b.enableClickArea())
                    }
                    this.selectedReelMode = -1;
                })
            }
        }
        this.tl.add(() => {
            // Make sure the deselected button is an available one in case button was changed due to bet level changed
            // https://github.com/nolimitcity/munchies/issues/87
            if(this.availableButtons.find(b => b == selectedButton) != undefined) {
                if(!Decadence.model.isRestore && !Decadence.apiPlugin.promotionHandler.hasFreeFeatureBet()) {
                    selectedButton.enableClickArea();
                }
            }
        });
    }

    onRestore():void {
        if(Decadence.model.initData.boostedBet) {
            const numberOfReels = Decadence.model.initData.reels.length;
            const restoreFeature:string|undefined = numberOfReels == 1 ? undefined : (numberOfReels == 2 ? "REELS_2" : "REELS_4");
            this.setButtonStatesFromFeature(restoreFeature);
        } else if(!Decadence.model.initData.wasFeatureBuy){
            this.setButtonStatesFromFeature(undefined);
        } else {
            this.setButtonStatesFromFeature("");
        }
    }

    onResize() {
        const isPortrait = !NolimitApplication.isLandscape;
        if(isPortrait) {
            this.position.y = DecadenceStatics.GAME_ELEMENTS_PORTRAIT_OFFSET;
        } else {
            this.position.y = 0;
        }
    }
}